import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowDownToBracket = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.38 21H7.62c-1.815 0-3.286-1.511-3.286-3.375v-2.531c0-.468.368-.844.822-.844s.821.378.821.844v2.531c0 .928.74 1.688 1.643 1.688h8.762c.903 0 1.643-.76 1.643-1.688v-2.531c0-.466.368-.844.821-.844.454 0 .822.378.822.844v2.531c0 1.863-1.472 3.375-3.286 3.375m-3.819-5.853 4.655-4.5a.86.86 0 0 0 .035-1.193.805.805 0 0 0-1.16-.036l-3.27 3.159V3.844A.83.83 0 0 0 12 3a.83.83 0 0 0-.822.844v8.733L7.906 9.416a.8.8 0 0 0-1.159.039.85.85 0 0 0-.223.576.85.85 0 0 0 .259.614l4.654 4.5a.8.8 0 0 0 1.124.002"
    }));
export default SvgArrowDownToBracket;
